export default __webpack_public_path__ + "static/media/picture-1.1a9bdb4c.png";